import {
  faBook,
  faCalendar,
  faCog,
  faCogs,
  faCoins,
  faFile,
  faFileInvoiceDollar,
  faMinusSquare,
  faStopwatch,
  faTachometerAlt,
  faUserCheck,
  faUsers,
  faUsersCog,
  faUserTimes
} from '@fortawesome/free-solid-svg-icons'
import {createUseStyles} from 'react-jss'
import {headerHeight} from '../../../constants/dimensons'
import SidebarLink from './SidebarLink'
import logo from '../../../assets/images/logo/cappy-symbol-pos.png'
import {Colors} from '../../../constants/colors'
import {useAppSelector} from '../../../redux/hooks'
import {Link, useLocation} from 'react-router-dom'
import {Fonts} from '../../../constants/fonts'
import {useTranslation} from 'react-i18next'
import Emitter from '../../../eventing/Emitter'
import {Events} from '../../../eventing/Events'
import {truncateString} from '../../../util/string'
import {RenderForCustomerPolicy} from "../../RenderForCustomerPolicy";
import { RenderForCompanyGroupPolicy } from '../../RenderForCompanyGroupPolicy'


const Sidebar = () => {
  const styles = useStyles()
  const location = useLocation();
  const {t} = useTranslation('common');

  const authenticatedUser = useAppSelector(state => state.auth.authenticatedUser)
  const currentCustomerId = useAppSelector(state => state.auth.currentCustomerId)
  const currentCompanyGroupId = useAppSelector(state => state.auth.currentCompanyGroupId) 
  const employeesPendingActivation = useAppSelector(state => state.employeeActivation.pendingEmployees)
  const employeesPendingDeactivation = useAppSelector(state => state.employeeDeactivation.pendingEmployees)
  const upcomingPayrolls = useAppSelector(state => state.payroll.upcomingPayrolls)
  const customer = useAppSelector(state => state.customer.customer)
  const companyGroup = useAppSelector(state => state.companyGroup.companyGroup)
  const files = useAppSelector(state => state.files.files)

  const getDuePayrollReportCount = () => {
    return upcomingPayrolls.filter(x => x.payrollFileDue || x.validationErrors?.length > 0).length;
  }

  const getActivationTodoCount = () => {
    return employeesPendingActivation.filter(x => x.bankAccountActivationFailed || !x.pendingBankAccountActivation).length;
  }

  const getDeactivationTodoCount = () => {
    return employeesPendingDeactivation.length;
  }

  const getNewFileCount = () => {
    return files.filter(x =>
      (x.employerPayDeductionPaymentNotificationFile != null && x.employerPayDeductionPaymentNotificationFile.lastDownloadDate == null) ||
      (x.creditReportFile != null && x.creditReportFile.lastDownloadDate == null) ||
      (x.agiAdjustmentSieFile != null && x.agiAdjustmentSieFile.lastDownloadDate == null)).length;
  }

  const getNewPaymentNotificationFileCount = () => {
    return files.filter(x => x.employerPayDeductionPaymentNotificationFile != null && x.employerPayDeductionPaymentNotificationFile.lastDownloadDate == null).length;
  }

  const renderCustomerMenu = () => {
    return (
    <>
      <h6 className={styles.sectionTitle}>{t('start')}</h6>
      <SidebarLink title={t('dashboard')} icon={faTachometerAlt} linkTo='/' active={location.pathname === '/'}/>

      <RenderForCustomerPolicy policy={"allowReadCreditReport"}>
        <h6 className={styles.sectionTitle}>{t('reports')}</h6>
        <SidebarLink
          title={t('creditUsage')}
          icon={faCoins}
          linkTo='/creditusage'
          active={location.pathname.startsWith('/creditusage')}/>
      </RenderForCustomerPolicy>

      <h6 className={styles.sectionTitle}>{t('manage')}</h6>

      <RenderForCustomerPolicy policy={"allowManageEmployeeActivations"}>
        {customer?.employer?.employeeActivationType !== 'automatic' &&
            <SidebarLink title={t('activations')} icon={faUserCheck} linkTo='/activations'
                          dotNumber={getActivationTodoCount()}
                          active={location.pathname.startsWith('/activations')}/>
        }
        {customer?.employer?.employeeDeactivationType === 'manual' &&
            <SidebarLink title={t('deactivations')} icon={faUserTimes} linkTo='/deactivations'
                          dotNumber={getDeactivationTodoCount()}
                          active={location.pathname.startsWith('/deactivations')}/>
        }
      </RenderForCustomerPolicy>

      <RenderForCustomerPolicy policy={"allowManageEmployees"}>
        <SidebarLink title={t('employees')} icon={faUsers} linkTo='/employees'
                      active={location.pathname.startsWith('/employees')}/>
      </RenderForCustomerPolicy>

      <RenderForCustomerPolicy policy={"allowManageShifts"}>
        <SidebarLink title={t('shifts')} icon={faStopwatch} linkTo='/shifts'
                      active={location.pathname.startsWith('/shifts')}/>
      
        {customer?.employer?.openShiftsEnabled &&
        <SidebarLink title={t('openShifts')} icon={faStopwatch} linkTo='/openShifts'
                      active={location.pathname.startsWith('/openShifts')}/>
        }
      </RenderForCustomerPolicy>

      <RenderForCustomerPolicy policy={"allowManagePayDeviations"}>
        <SidebarLink title={t('deviations')} icon={faMinusSquare} linkTo='/deviations'
                      active={location.pathname.startsWith('/deviations')}/>
      </RenderForCustomerPolicy>

      <RenderForCustomerPolicy policy={"allowManagePaySchedules"}>
        <SidebarLink title={t('paySchedules')} icon={faCalendar} linkTo='/paySchedules'
                      active={location.pathname.startsWith('/paySchedules')}/>
      </RenderForCustomerPolicy>

      {customer?.employer?.adminFlowType === 'agiAdjustment' &&
          <>
              <RenderForCustomerPolicy policy={"allowManageAgi"}>
                  <SidebarLink title={t('agiAdjustment')} icon={faFileInvoiceDollar} linkTo='/agiAdjustment'
                                active={location.pathname.startsWith('/agiAdjustment')}/>

              </RenderForCustomerPolicy>
              <RenderForCustomerPolicy policy={"allowManageFora"}>
                  <SidebarLink title={t('foraAdjustment')} icon={faFileInvoiceDollar}
                                linkTo='/foraAdjustment'
                                active={location.pathname.startsWith('/foraAdjustment')}/>
              </RenderForCustomerPolicy>
          </>
      }

      <RenderForCustomerPolicy policy={"allowManagePayroll"}>
        {customer?.employer?.adminFlowType === 'basisImport' &&
            <SidebarLink title={t('payoutBasis')} icon={faFileInvoiceDollar} linkTo='/payoutBasis'
                          active={location.pathname.startsWith('/payoutBasis')}/>
        }
        <SidebarLink title={t('payroll')} icon={faFileInvoiceDollar} linkTo='/payroll'
                      dotNumber={getDuePayrollReportCount()}
                      active={location.pathname.startsWith('/payroll')}/>
      </RenderForCustomerPolicy>

      {customer?.employer?.adminFlowType === 'basisImport' &&
          <RenderForCustomerPolicy policy={"allowReadPaymentNotificationFile"}>
              <SidebarLink title={t('paymentNotifications')} icon={faFileInvoiceDollar}
                            linkTo='/paymentNotifications' dotNumber={getNewPaymentNotificationFileCount()}
                            active={location.pathname.startsWith('/paymentNotifications')}/>
          </RenderForCustomerPolicy>}


      <h6 className={styles.sectionTitle}>{t('files')}</h6>
      <SidebarLink title={t('files')} icon={faFile} linkTo='/customerfiles' dotNumber={getNewFileCount()}
                    active={location.pathname.startsWith('/customerfiles')}/>

      <RenderForCustomerPolicy policy={["allowViewIntegrationLog", "allowManageIntegrations"]}>
        <h6 className={styles.sectionTitle}>{t('integration')}</h6>
        {(customer?.portalIntegrations?.length ?? 0) > 0 &&
            <RenderForCustomerPolicy policy={"allowManageIntegrations"}>
                <SidebarLink title={t('integration')} icon={faCogs} linkTo='/integrations'
                              active={location.pathname.startsWith('/integrations')}/>
            </RenderForCustomerPolicy>
        }
        <RenderForCustomerPolicy policy={"allowViewIntegrationLog"}>
          <SidebarLink title={t('log')} icon={faCogs} linkTo='/integrationlog'
                        active={location.pathname.startsWith('/integrationlog')}/>
        </RenderForCustomerPolicy>
      </RenderForCustomerPolicy>

      <RenderForCustomerPolicy
        policy={["allowManageCompanySettings", "allowManageUsers", "allowManageBookkeepingSettings"]}>
        <h6 className={styles.sectionTitle}>{t('settings')}</h6>

        <RenderForCustomerPolicy policy={"allowManageCompanySettings"}>
          <SidebarLink title={t('companySettings')} icon={faCog} linkTo='/companysettings'
                        active={location.pathname.startsWith('/companysettings')}/>
        </RenderForCustomerPolicy>

        {customer?.employer?.adminFlowType == 'agiAdjustment' &&
            <RenderForCustomerPolicy policy={"allowManageBookkeepingSettings"}>
                <SidebarLink title={t('bookkeepingSettings')} icon={faBook} linkTo='/bookkeepingsettings'
                              active={location.pathname.startsWith('/bookkeepingsettings')}/>
            </RenderForCustomerPolicy>}

        <RenderForCustomerPolicy policy={"allowManageUsers"}>
          <SidebarLink title={t('portalUsers')} icon={faUsers} linkTo='/customerportalusers'
                        active={location.pathname.startsWith('/customerportalusers')}/>
          <SidebarLink title={t('portalRoles')} icon={faUsersCog} linkTo={'/customerportalroles'}
                        active={location.pathname.startsWith('/customerportalroles')}/>
        </RenderForCustomerPolicy>
      </RenderForCustomerPolicy>
    </>
    )
  }

  const renderCompanyGroupMenu = () => {
    return (
    <>
      <h6 className={styles.sectionTitle}>{t('files')}</h6>
      <RenderForCompanyGroupPolicy policy={["allowManagePayroll"]}>
        <SidebarLink title={t('files')} icon={faFile} linkTo='/companygroupfiles' active={location.pathname.startsWith('/companygroupfiles')}/>
      </RenderForCompanyGroupPolicy>
      <RenderForCompanyGroupPolicy policy={["allowManageEmployeeActivations"]}>
        <SidebarLink 
          title={t('deactivations')} 
          icon={faFile} 
          dotNumber={getDeactivationTodoCount()}
          linkTo='/companygroupemployeedeactivations' 
          active={location.pathname.startsWith('/companygroupemployeedeactivations')}/>
      </RenderForCompanyGroupPolicy>
      <RenderForCompanyGroupPolicy policy={["allowManageUsers"]}>
        <h6 className={styles.sectionTitle}>{t('settings')}</h6>
          <SidebarLink title={t('portalUsers')} icon={faUsers} linkTo='/companygroupportalusers'
                        active={location.pathname.startsWith('/companygroupportalusers')}/>
          <SidebarLink title={t('portalRoles')} icon={faUsersCog} linkTo={'/companygroupportalroles'}
                        active={location.pathname.startsWith('/companygroupportalroles')}/>

      </RenderForCompanyGroupPolicy>
    </>
    )
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <div className={styles.logoContainer}>
            <Link to="/"><img className={styles.logo} src={logo} alt=''/></Link>
          </div>
          <div className={styles.loggedInUserContainer}>
            <div className={styles.loggedInUser} onClick={() => Emitter.emit(Events.displayProfile)}>
              {truncateString(`${authenticatedUser?.givenName} ${authenticatedUser?.familyName}`, 26)}
            </div>
            <div className={styles.company} title={customer?.legalName}>
              {truncateString(customer?.legalName ?? companyGroup?.name ?? '', 26)}
            </div>
          </div>
        </div>
        <div className={styles.mainContainer}>
          {currentCustomerId == null && currentCompanyGroupId != null && renderCompanyGroupMenu()}
          {currentCustomerId != null && renderCustomerMenu()}
        </div>
      </div>
    </>
  )
}

export default Sidebar

const useStyles = createUseStyles({
  container: {
    color: Colors.gray1,
  },
  headerContainer: {
    position: 'relative',
    height: headerHeight,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    columnGap: 10,
    paddingLeft: 30
  },
  mainContainer: {
    zIndex: 0,
    paddingTop: 20,
    paddingBottom: headerHeight,
    backgroundColor: '#ffffff',
    overflowY: 'auto',
    height: '100vh'
  },
  sectionTitle: {
    marginTop: 20,
    marginLeft: 20,
    marginBottom: 10,
    textTransform: 'uppercase',
    fontSize: 15
  },
  logo: {
    width: 50
  },
  loggedInUserContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  logoContainer: {
    padding: 3
  },
  loggedInUser: {
    color: Colors.euro_800,
    fontFamily: Fonts.semiBold,
    cursor: 'pointer'
  },
  company: {
    color: Colors.gray3,
    fontSize: 13
  }
})
